import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/axios';
import './plugins/bootstrap-vue';
import './plugins/functions';
import './plugins/vue-session';
import './plugins/weightClasses';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.prototype.$log(`running in "${process.env.NODE_ENV}" mode`);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
